import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { CallToAction, Heading } from '@scentregroup/ui'
import { Link } from 'react-router-dom'
import trackEvent from '../../../helpers/analytics-utils/track-event'
import EventNotification from '../../event-notification'
import { CountryContext } from '../../../context'
import style from './index.scss'

export const isService = (contentTypes, entries) => {
  if (contentTypes) {
    return contentTypes.includes('Service')
  } else {
    return entries && entries.find(entry => entry.contentTypeId === 'service')
  }
}

const showCovidNotification = (country, contentTypes, entries) => {
  if (country !== 'Australia') {
    return false
  }
  return isService(contentTypes, entries)
}

const Spotlight = ({
  className,
  children,
  heading,
  superHeading,
  callToAction,
  alternateDesign,
  contentTypes,
  entries,
}) => (
  <div
    className={classNames(
      style.Spotlight,
      {
        [style.SpotlightAlternative]: alternateDesign,
      },
      className
    )}
  >
    {superHeading && (
      <Heading type="extrasmall" className={style.superHeading}>
        {superHeading}
      </Heading>
    )}
    <Heading
      type="large"
      className={classNames(style.heading, {
        [style.headingAlternative]: alternateDesign,
      })}
    >
      {heading}
    </Heading>
    <CountryContext.Consumer>
      {country => (
        <>
          {showCovidNotification(country, contentTypes, entries) && (
            <EventNotification message="Please note, due to COVID-19 certain centre services are currently unavailable" />
          )}
        </>
      )}
    </CountryContext.Consumer>
    <div className={style.childWrapper}>{children}</div>
    {callToAction && callToAction.address && (
      <div className={style.callToActionWrapper}>
        <CallToAction
          element={Link}
          to={callToAction.address}
          className={style.callToAction}
          onClick={
            callToAction.eventCategory
              ? () =>
                  trackEvent(
                    callToAction.eventCategory,
                    callToAction.eventAction,
                    callToAction.eventLabel
                  )
              : null
          }
        >
          {callToAction.text}
        </CallToAction>
      </div>
    )}
  </div>
)

Spotlight.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  callToAction: PropTypes.shape({
    category: PropTypes.string,
    address: PropTypes.string,
    analytics: PropTypes.object,
    text: PropTypes.string.isRequired,
    eventCategory: PropTypes.string,
    eventAction: PropTypes.string,
    eventLabel: PropTypes.string,
  }),
  entries: PropTypes.array,
  contentTypes: PropTypes.array,
  heading: PropTypes.string,
  superHeading: PropTypes.string,
  alternateDesign: PropTypes.bool,
}

export default Spotlight
